<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="5" @click="toNewRouter('site-over-view')" v-if="permissionCodes.indexOf('008006000') !== -1">
        <i class="el-icon-damai-ic_gailan1" style="font-size: 16px;"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('site-facilities-manage')" v-if="permissionCodes.indexOf('008001000') !== -1">
        <i class="el-icon-damai-ic_sheshiguanli"></i>
        <span slot="title">设施管理</span>
      </el-menu-item>
      <el-menu-item index="1" @click="toNewRouter('site-management')" v-if="permissionCodes.indexOf('008002000') !== -1">
        <i class="el-icon-damai-ic_changdiguanli"></i>
        <span slot="title">场地管理</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('bespoke-record')" v-if="permissionCodes.indexOf('008003000') !== -1">
        <i class="el-icon-damai-ic_yuyuejilu"></i>
        <span slot="title">预约记录</span>
      </el-menu-item>
      <el-menu-item index="7" @click="toNewRouter('site-bill')" v-if="permissionCodes.indexOf('008004000') !== -1">
        <i class="el-icon-damai-ic_yuyuejilu"></i>
        <span slot="title">预约账单</span>
      </el-menu-item>
<!--      <el-menu-item index="3" @click="toNewRouter('site-pay-record')" v-if="permissionCodes.indexOf('008003000') !== -1">-->
<!--        <i class="el-icon-damai-ic_zhangdanguanli"></i>-->
<!--        <span slot="title">缴费记录</span>-->
<!--      </el-menu-item>-->
      <el-menu-item index="4" @click="toNewRouter('site-reservation-log')" v-if="permissionCodes.indexOf('008005000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: ["site-management", "site-add", "site-current", "site-modify"],
  2: ["bespoke-record"],
  3: ["site-pay-record"],
  4: "site-reservation-log",
  5: "site-over-view",
  6: [
    "site-facilities-manage",
    "site-facilities-add",
    "site-facilities-modify"
  ],
  7: ["site-bill", "site-bill-modify"]
});

export default {
  name: "investment-leasing-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/SiteReservation/SiteReservationNav.vue